export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7069.02b50da3.jpg";